import { Component } from '@verndale/core'
import { rovingIndex } from '@verndale/roving-ux'

class Module extends Component {
  setupDefaults() {
    // Removing rovingIndex due to a scroll bug.
    // rovingIndex({
    //   element: this.el,
    //   target: '.accordion-item__button'
    // })
  }
}

export default Module
